<!--
 * @Author: wangyan1
 * @Description: 双列表查看组件
 * @Date: 2022-05-06 15:35
 * @LastEditTime: 2022-05-06 15:35
 * @FilePath: /teacher-xkh-web/src/views/groupManage/components/viewReport.vue
-->
<template>
  <div class="tabs-detail">
    <a-tabs v-model="activeKey" tab-position="left">
      <a-tab-pane v-for="(item, index) in correctionList" :key="index" :tab="`第${item.lessonNum}讲`">
        <div class="tabs-step" v-for="(detail, idx) in item.detailList" :key="idx">
          {{ detail.linkTypeName }}
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default ({
  props: {
    correctionList: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      // correctionList,
      activeKey: 0
    }
  }
})
</script>

<style scoped lang="less">
@import '~@/static/css/base.less';
.tabs-detail{
  .ant-tabs-line {
    height: auto;
    padding-left: 0;
  }
  .tabs-step {
    padding: 4px 0;
  }
  :deep(.ant-tabs-left) {
    &:before {
      border-right: 1px solid #fff;
      position: absolute;
      height: 100%;
      left: 50%;
    }
    .ant-tabs-tab {
      width: 80px;
      color: #a0a0a0;
      text-align: left;
      padding: 4px 0;
      &:hover,
      &.ant-tabs-tab-active {
        color: #fff;
      }
    }
    .ant-tabs-left-content {
      padding: 0;
      border-left: 0 none;
    }
    .ant-tabs-ink-bar {
      background: none;
    }
    .ant-tabs-tabpane {
      width: 70px;
      text-align: center;
      color: #fff;
    }
    .ant-tabs-bar {
      border: 0 none;
      width: 70px;
    }
  }
}
</style>
